<div class="app-tooltip">{{ text }}</div>
